export enum clientPageTypeEnum {
  UNIVERSAL_TYPE = 0,
  INVENTORY_WORK_LIST_TYPE = 1,
  INVENTORY_WORK_PREVIEW_TYPE = 2,
  CONTACT_LIST_TYPE = 3,
  CONTACT_PREVIEW_TYPE = 4,
  NEWS_LIST_TYPE = 5,
  NEWS_PREVIEW_TYPE = 6,
  EXHIBITION_LIST_TYPE = 7,
  EXHIBITION_PREVIEW_TYPE = 8,
  PRIVATE_VIEW_TYPE = 9,
  PRIVATE_VIEW_WORK_PREVIEW_TYPE = 10,
  CONTACT_PAGE_TYPE = 11,
  MAIN_PAGE_TYPE = 12,

  NOT_FOUND_PAGE_TYPE = 13,

  //#region e-commerce types

  /**
   * @description
   * Client account login
   */
  CLIENT_ACCOUNT_LOGIN = 14,

  /**
   * @description
   * Client account register type
   */
  CLIENT_ACCOUNT_REGISTER = 15,

  /**
   * @description
   * Client account password recovery page
   */
  CLIENT_ACCOUNT_PASSWORD_RECOVERY = 16,
  CONFIRM_ACTIVATED_ECOMMERCE_ACCOUNT_PAGE_TYPE = 17,
  CONFIRM_RESET_PASSWORD_ECOMMERCE_PAGE_TYPE = 18,
  CONFIRM_SUBMIT_ORDER_PAGE_TYPE = 19,
  SUCCESS_PAYMENT_PAGE_TYPE = 20,
  FAILURE_PAYMENT_PAGE_TYPE = 21,
  EXHIBITION_WORK_PREVIEW_TYPE = 22,
  GLOBAL_SEARCH_RESULTS_PAGE_TYPE = 23,
  TERMS_AND_CONDITIONS_PAGE_TYPE = 24,

  //#endregion
}

export const MAIN_PAGE_TYPE = [
  clientPageTypeEnum.MAIN_PAGE_TYPE
];

export const LIST_PAGE_TYPES = [
  clientPageTypeEnum.INVENTORY_WORK_LIST_TYPE,
  clientPageTypeEnum.CONTACT_LIST_TYPE,
  clientPageTypeEnum.NEWS_LIST_TYPE,
  clientPageTypeEnum.EXHIBITION_LIST_TYPE,
  clientPageTypeEnum.GLOBAL_SEARCH_RESULTS_PAGE_TYPE,
];
export const PREVIEW_PAGE_TYPES = [
  clientPageTypeEnum.INVENTORY_WORK_PREVIEW_TYPE,
  clientPageTypeEnum.PRIVATE_VIEW_WORK_PREVIEW_TYPE,
  clientPageTypeEnum.PRIVATE_VIEW_TYPE,
  clientPageTypeEnum.CONTACT_PREVIEW_TYPE,
  clientPageTypeEnum.NEWS_PREVIEW_TYPE,
  clientPageTypeEnum.EXHIBITION_PREVIEW_TYPE,
  clientPageTypeEnum.EXHIBITION_WORK_PREVIEW_TYPE,
];
